import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-850ef79c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-wrap icon-fuwu" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "极加服务订单", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-wrap icon-fuwu" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "无忧计划订单", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-wrap icon-fuwu" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "维修单/升级保养订单", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-wrap icon-fuwu" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "服务费用单", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-wrap icon-fuwu" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "铭牌三证补办订单", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-wrap icon-fuwu" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "付费技术支持订单", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]

import {} from 'vue'
import { useRouter } from 'vue-router'
import AppHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-order-list',
  setup(__props) {

const $router = useRouter()
function back() {
  AppHost.goAppBack()
}
function gotoJijia() {
  $router.push({
    name: 'jijia-order-list',
  })
}
function gotoWuyou() {
  $router.push({
    name: 'insurance-wuyou-order',
  })
}
function gotoRepairOrder() {
  $router.push({
    name: 'insurance-repair-order',
  })
}
function gotoServieChargeOrder() {
  $router.push({
    name: 'service-charge-order',
  })
}
function gotoNameplateReissueOrder() {
  $router.push({
    name: 'nameplate-reissue-order',
  })
}

function gotoPaidTechnicalSupportOrder() {
  $router.push({
    name: 'malfunction-repair-paid-technical-support-order',
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "我的发票",
      isReturnLeftEvent: "",
      onLeftClick: back
    }),
    _createElementVNode("ul", { class: "order-list" }, [
      _createElementVNode("li", { onClick: gotoJijia }, _hoisted_4),
      _createElementVNode("li", {
        onClick: gotoWuyou,
        class: "van-hairline--top"
      }, _hoisted_8),
      _createElementVNode("li", {
        onClick: gotoRepairOrder,
        class: "van-hairline--top"
      }, _hoisted_12),
      _createElementVNode("li", {
        onClick: gotoServieChargeOrder,
        class: "van-hairline--top"
      }, _hoisted_16),
      _createElementVNode("li", {
        onClick: gotoNameplateReissueOrder,
        class: "van-hairline--top"
      }, _hoisted_20),
      _createElementVNode("li", {
        onClick: gotoPaidTechnicalSupportOrder,
        class: "van-hairline--top"
      }, _hoisted_24)
    ])
  ], 64))
}
}

})